<div class="container-msg">
    <mat-card class="example-card">
        <mat-card-header>
            <mat-card-title>Registrado con éxito</mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <div class="container-check-circle">
                <div
                    class="flex flex-0 items-center justify-center w-8 h-8 rounded-full ring-2 ring-inset ring-transparent bg-card dark:bg-default bg-primary dark:bg-primary text-on-primary group-hover:bg-primary-800"
                    ng-reflect-ng-class="[object Object]">
                    <mat-icon _ngcontent-fdw-c408="" role="img"
                              class="mat-icon notranslate icon-size-5 text-current mat-icon-no-color ng-star-inserted"
                              aria-hidden="true" ng-reflect-svg-icon="heroicons_solid:check" data-mat-icon-type="svg"
                              data-mat-icon-name="check" data-mat-icon-namespace="heroicons_solid" style="">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" fit=""
                             height="100%" width="100%" preserveAspectRatio="xMidYMid meet" focusable="false">
                            <path fill-rule="evenodd"
                                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                  clip-rule="evenodd"></path>
                        </svg>
                    </mat-icon>
                </div>
            </div>
            <p class="text-msg-success">
                Su registro de usuario ha sido creado de manera éxitosa!
            </p>
        </mat-card-content>
    </mat-card>
</div>
